import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { LeadService } from 'app/platform/lead/lead.service';
import { LoaderService } from 'app/services/loader.service';

@Component({
  selector: 'app-zero-to-forty',
  templateUrl: './zero-to-forty.component.html',
  styleUrls: ['./zero-to-forty.component.css'],
  providers: [LeadService]
})
export class ZeroToFortyComponent implements OnInit {
  items: any;
  // cascading_items: any;
  allowed_items = 'zero_to_40';
  current_page: any = 1;
  per_page: any = 10;
  total_page;
  current_user_id;
  selectedGmItems = [];
  gm_dropdownSettings = {
    singleSelection: false,
    text: "General Managers",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "myclass custom-class-dropdown",
  };
  cm_dropdownSettings = {
    singleSelection: false,
    text: "Community Managers",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "myclass custom-class-dropdown",
  };
  designer_dropdownSettings = {
    singleSelection: false,
    text: "Designers",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "myclass custom-class-dropdown",
  };
  gm_dropdownList = [];
  cm_dropdownList = [];
  designer_dropdownList = [];
  role: string;
  from_date;
  to_date;

  @Output() messageEvent = new EventEmitter<string>();
  @Output() abcevent = new EventEmitter<string>();

  
  constructor(
    private leadService: LeadService,
    private loaderService: LoaderService
  ) { }


  ngOnInit() {
    this.current_page = 1;
    this.current_user_id = localStorage.getItem('userId');
    this.role = localStorage.getItem('user');
    if (this.role === ('business_head') ) {
      this.getGMList();
    }
    if (this.role === ('city_gm')) {
      this.getCMList(this.current_user_id);
    }
    if (this.role === ('community_manager')) {
      this.getDesignerList(this.current_user_id);
    }
    this.getColumnFilterValues();
    this.getItems(1, '', '',1,1,1,'','','','','','','');
  }
  page_number;
  // current_page = '1';
  featured;
  searched_item: any = '';
  closureValue;
  gmValue;
  cmValue;
  designerValue;
  errorMessage: string;
  successMessage: string;
  msgError: boolean = false;
  successError: boolean = false;

  item_delayed;
  item_start_date;
  item_end_date;
  item_date_column;
  send_file;
  sorting_col;
  sorting_ord;
  getItems(pageno: any, searched: any, featured, gM, cM, dEsigner, delayed, datestart, dateend, date_column, file_data, sort_column, sort_order) {
    if (file_data === undefined || file_data === '') {
      this.send_file = false;
    }
    else if (file_data !== undefined) {
      this.send_file = true;
    }
    else if (this.send_file === undefined) {
      this.send_file = false;
    }
    if (sort_column === undefined || sort_column === '') {
      this.sorting_col = '';
    }
    else if (this.sorting_col === undefined) {
      this.sorting_col = '';
    }
    else if (sort_column !== '') {
      this.sorting_col = sort_column;
    }
    // if (this.sorting_col !== '' && this.sorting_col !== undefined && sort_column === '') {
    //   this.sorting_col = this.sorting_col;
    // }
    
    if (sort_order === undefined || sort_order === '') {
      this.sorting_ord = '';
    }
    else if (this.sorting_ord === undefined) {
      this.sorting_ord = '';
    }
    else if (sort_order !== '') {
      this.sorting_ord = sort_order;
    }
    if (featured === undefined) {
      featured = this.featured
    }
    if (featured === 1) {
      featured = this.featured
    }
    if (gM === 1) {
      this.gmValue = ''
    }
    else if (this.gmValue !== '') {
      this.gmValue = this.gmValue;
    }
    else (
      this.gmValue = gM
    )
    if (cM === 1) {
      this.cmValue = ''
    }
    else if (this.cmValue !== '') {
      this.cmValue = this.cmValue;
    }
    else (
      this.cmValue = cM
    )
    if (dEsigner === 1) {
      this.designerValue = ''
    }
    else if (this.designerValue !== '') {
      this.designerValue = this.designerValue;
    }
    else (
      this.designerValue = dEsigner
    )
    
    if (delayed === 1) {
      this.item_delayed = '';
    }
    if (datestart === 1) {
      this.item_start_date = '';
    }
    if (dateend === 1) {
      this.item_end_date = '';
    }
    if (date_column === 1) {
      this.item_date_column = '';
    }
    if (this.item_delayed !== '' && this.item_delayed !== undefined && delayed !== 1 && delayed === '') {
      this.item_delayed = this.item_delayed;
    }

    if (this.item_delayed !== '' && this.item_delayed !== undefined && delayed !== 1 && delayed !== '') {
      this.item_delayed = delayed;
    }

    else if (this.item_delayed === '' && delayed !== 1) {
      this.item_delayed = delayed
    }
    else if (this.item_delayed === undefined) {
      this.item_delayed = delayed
    }
    // this.item_delayed = delayed;
    if (this.item_start_date !== '' && this.item_start_date !== undefined && datestart !== 1 && datestart === '') {
      this.item_start_date = this.item_start_date;
    }
    if (this.item_start_date !== '' && this.item_start_date !== undefined && datestart !== 1 && datestart !== '') {
      this.item_start_date = datestart;
    }
    else if (this.item_start_date === '' && datestart !== 1) {
      this.item_start_date = datestart
    }
    else if (this.item_start_date === undefined) {
      this.item_start_date = datestart
    }
    // this.item_start_date = datestart;
    if (this.item_end_date !== '' && this.item_end_date !== undefined && dateend !== 1 && dateend === '') {
      this.item_end_date = this.item_end_date;
    }
    if (this.item_end_date !== '' && this.item_end_date !== undefined && dateend !== 1 && dateend !=='') {
      this.item_end_date = dateend;
    }
    else if (this.item_end_date === '' && dateend !== 1) {
      this.item_end_date = dateend
    }
    else if (this.item_end_date === undefined) {
      this.item_end_date = dateend
    }
    // this.item_end_date = dateend;
    if (this.item_date_column !== '' && this.item_date_column !== undefined && date_column !==1 && date_column === '') {
      this.item_date_column = this.item_date_column;
    }
    if (this.item_date_column !== '' && this.item_date_column !== undefined && date_column !==1 && date_column !== '') {
      this.item_date_column = date_column;
    }
    else if (this.item_date_column === '' && date_column !== 1) {
      this.item_date_column = date_column
    }
    else if (this.item_date_column === undefined) {
      this.item_date_column = date_column
    }
    // this.item_date_column = date_column;
    
    // this.searched_item = searched;
    if (searched === 1) {
      this.searched_item = '';
    }
    if (this.searched_item !== '' && this.searched_item !== undefined && searched === 1) {
      this.searched_item = '';
    }

    if (this.searched_item !== '' && this.searched_item !== undefined && searched === '') {
      this.searched_item = this.searched_item;
    }
    if (this.searched_item !== '' && this.searched_item !== undefined && searched !== '' && searched !== 1) {
      this.searched_item = searched;
    }
    if (this.searched_item === '' && this.searched_item !== undefined && searched !== '' && searched !== 1) {
      this.searched_item = searched;
    }
    else if (this.searched_item === undefined) {
      this.searched_item = searched
    }
    this.current_page = pageno;
    this.featured = featured;
    this.per_page = 10;
    this.loaderService.display(true);
    this.leadService.getListwithType(this.allowed_items, this.current_page, 10, this.searched_item, this.featured, this.gmValue, this.cmValue, this.designerValue, this.item_delayed, this.item_start_date, this.item_end_date, this.item_date_column, this.send_file,this.sorting_col,this.sorting_ord).subscribe(res => {
      if (res.success === true) {
        this.successError = true;
          this.successMessage = "The report you requested is being created. It will be emailed to you once completed.!";
          setTimeout(function () {
            this.successError = false;
          }.bind(this), 6000);
          this.loaderService.display(false);
      }
      else{
        this.items = res.lead_noc_data;
        if (this.items.length === 0) {
          this.msgError = true;
          this.errorMessage = "No Lead Data Found";
          setTimeout(function () {
            this.msgError = false;
          }.bind(this), 7000);
          this.current_page = res.current_page;
          this.total_page = res.zero_to_40_count;
          this.per_page = 10;
          this.closureValue = res.closure_collected_amount
          this.messageEvent.emit(this.total_page);
          this.abcevent.emit(this.closureValue);
          this.loaderService.display(false);
        }
        else {
          this.msgError = false;
          this.current_page = res.current_page;
          this.total_page = res.zero_to_40_count;
          this.per_page = 10;
          this.closureValue = res.closure_collected_amount
          this.messageEvent.emit(this.total_page);
          this.abcevent.emit(this.closureValue);
          this.loaderService.display(false);
        }
      }
    })
  }

  cascading_items;
  showDetails: boolean = true;
  getBOQdetails(leadId: any, index: any) {
    
    this.cascading_items = [];
    // this.showDetails = false;
    this.leadService.getBOQDetails(leadId).subscribe(response => {
      
      this.cascading_items = response.quotations;
      if (response.quotations.length === 0) {
        // $('.location').hide()
        // $('#Location' + index).hide();
        this.showDetails = false;
        alert("No BOQ Data Present");
        $('.location').hide()
      }
      else {
        this.showDetails = true;
      }
    })
  }

  value: any;
  getfeatured(data: any) {
    
    this.value = data;
    this.getItems(this.current_page, '', this.value,'','','','','','','','','','');
  }

  obj_list: any;
  featureddata(lead_id: any) {
    
    this.obj_list = {
      'lead_id': lead_id,
      'type': this.allowed_items
    }
    this.leadService.addToFeatured(this.obj_list).subscribe(res => {
      alert('Lead Added to featured');
      $(window).scrollTop(0);
      setTimeout(function () {
      }.bind(this), 2000);
      this.getItems(this.current_page, '', 'true',1,1,1,'','','','','','','');
    })
  }

  removefeatureddata(lead_id: any) {
    this.obj_list = {
      'lead_id': lead_id,
      'type': this.allowed_items
    }
    this.leadService.removefromFeatured(this.obj_list).subscribe(res => {
      alert('Lead Removed From Featured');
      $(window).scrollTop(0);
      setTimeout(function () {
      }.bind(this), 2000);
      this.getItems(this.current_page, '', 'false',1,1,1,'','','','','','','');
    })
  }

  // expanded: boolean;
  toggleRow(data, i) {
    data.expanded = !data.expanded;
    $('.location').hide()
    $('#Location'+i).show()
    // data.expanded = !data.expanded;
  }
  expansion: boolean;
  toggleRow1(id) {
    id.expansion = !id.expansion;
  }

  tenData: any;
  tenpayment(data: any) {
    console.log('ten payment', data);
    this.tenData = data;
  }

  fortyData: any;
  fortypayments(data: any) {
    this.fortyData = data;
  }

  firstMeetingData: any;
  firstmeeting(data: any) {
    this.firstMeetingData = data[0];
  }

  tenquoteData: any;
  tenquotepayment(data: any) {
    this.tenquoteData = data;
  }

  fortyquoteData: any;
  fortyquotepayment(data: any) {
    this.fortyquoteData = data;
  }

  searched_value: any;
  searchFilter(term: any) {
    this.searched_value = term.target.value;
    if (this.searched_value !== '') {
      this.getItems(1, this.searched_value, this.featured, 1, 1, 1, '', '', '', '','','','');
    }
    else if (this.searched_value === '') {
      this.getItems(1, 1, this.featured, 1, 1, 1, '', '', '', '','','','');
    }
  }
  getGMList() {
    this.leadService.getGMList(this.current_user_id).subscribe(res => {
      
      this.gm_dropdownList = res.gms_list;
      this.gm_dropdownList = this.gm_dropdownList.map((item) => {
        return {
          id: item.id,
          itemName: item.item_name
        }
      })
      
    })
  }

  gmlist;
  getCMList(id: any) {
    this.gmlist = id;
    this.leadService.getCMList(this.current_user_id, this.gmlist).subscribe(res => {
      this.cm_dropdownList = res.cms_list;
      this.cm_dropdownList = this.cm_dropdownList.map((item) => {
        return {
          id: item.id,
          itemName: item.item_name
        }
      })
      // this.getItems(1,'',this.featured,this.gmlist)
    })
  }

  cmlist;
  getDesignerList(id: any) {
    this.cmlist = id;
    this.leadService.getDesignerListNOC(this.current_user_id, this.cmlist).subscribe(res => {
      this.designer_dropdownList = res.designers_list;
      this.designer_dropdownList = this.designer_dropdownList.map((item) => {
        return {
          id: item.id,
          itemName: item.item_name
        }
      })
    })
  }

  cms;
  selectedCmItems = [];
  gms;
  designers;
  selectedDesignerItems = [];
  // selectedGmItems = [];
  onItemSelect(items, textVal?, index?) {
    
    if (textVal == 'cm' && index == 1) {
      this.cms = [];
      for (var k = 0; k < this.selectedCmItems.length; k++) {
        this.cms.push(this.selectedCmItems[k].id);
      }
      this.getDesignerList(this.cms);
      this.getItems(1,'',this.featured,'',this.cms,'','','','','','','','')
    }
      //  this.getDAYData();
      //  this.getCMsAndDesForCity();
      
      // } 
      else if(textVal=='designer' && index == 2){      
        this.designers = [];
        for(var k=0;k<this.selectedDesignerItems.length;k++){
        this.designers.push(this.selectedDesignerItems[k].id);
      }
      this.getItems(1,'',this.featured,'','',this.designers,'','','','','','','')

      } 
      if (textVal == 'gm' && index == 3) {
        this.gms = [];
        for (var k = 0; k < this.selectedGmItems.length; k++) {
          this.gms.push(this.selectedGmItems[k].id);
        }
        this.getCMList(this.gms);
        this.getItems(1,'',this.featured,this.gms,'','','','','','','','','')
        // this.getDAYData();
        // this.getCMsAndDesForCity();
   
      
    }
  }
  OnItemDeSelect(items, textVal?, index?) {
    
    // if(textVal=='cm' && index==1){
    //   for(var k=0;k<this.cms.length;k++){
    //     if(items.id == this.cms[k]){
    //       this.cms.splice(k,1);
          
    //     }
    //   }
    //   // this.getDAYData();
    
    //  }
    if (textVal == 'gm' && index == 3) {
      for (var k = 0; k < this.gms.length; k++) {
        if (items.id == this.gms[k]) {
          this.gms.splice(k, 1);
          
        }
      }
      //   this.getDAYData();
      //   this.getCMsAndDesForCity();
      //  }
      // if(textVal=='designer' && index==2){
      //   for(var k=0;k<this.designers.length;k++){
      //     if(items.id == this.designers[k]){
      //       this.designers.splice(k,1);
          
      //     }
      //   }
      //   this.getDAYData();
   
      // }
    }

    

  }
  onSelectAll(items){}
  onDeSelectAll(items) { }
  
  ClearGmFilter(){
    this.selectedGmItems=[];
    this.gms=[];
    this.getItems(1,'',this.featured,1,'','','','','','','','','');
  }
  
  ClearCmFilter() {
    this.selectedCmItems=[];
    this.cms = [];
    this.getItems(1,'',this.featured,'',1,'','','','','','','','');
  }
  CleardesignerFilter() {
    this.selectedDesignerItems = [];
    this.designers = [];
    this.getItems(1,'',this.featured,'','',1,'','','','','','','');
  }

  ClearAreaFilter(){
    this.featured=false;
    this.getItems(1,'',this.featured,'','','','','','','','','','');
  }

  delayed_data:any = 1;
  redflagclick(delayed) {
    this.delayed_data = delayed;
    this.getItems(1, '', '', '', '', '', delayed,'','','','','','');
  }


  date_values: any;
  getColumnFilterValues() {
    this.leadService.getColumnfilterdate().subscribe(res => {
      this.date_values = res;
    })
  }

  
  date_dropdown;
  dateDropDownChanged(event: any) {
    
    this.date_dropdown = event;
  }
  final_from_date;
  final_to_date;
  submitByDate() {
    
    if (this.from_date !== null) {
      var todayTime = this.from_date;
      var month = parseInt(("0" + (todayTime.getMonth() + 1)).slice(-2));;
      var day = todayTime.getDate();
      var year = todayTime.getFullYear();
      this.final_from_date = day + "-" + month + "-" + year;
    }
    if (this.to_date !== null) {
      var todayTime = this.to_date;
      var month = parseInt(("0" + (todayTime.getMonth() + 1)).slice(-2));;
      var day = todayTime.getDate();
      var year = todayTime.getFullYear();
      this.final_to_date = day + "-" + month + "-" + year;
    }
    this.getItems(1, '', '', '', '', '', '', this.final_from_date, this.final_to_date, this.date_dropdown,'','','');;
  }
  ClearDateFilter() {
    
    this.item_start_date = '';
    this.item_end_date = '';
    this.item_date_column = '';
    this.from_date = '';
    this.to_date = '';
    this.date_dropdown = "";
    this.getItems(1, '', '', '', '', '', '',1,1,1,'','','');
  }
  ClearFlagFilter() {
    this.delayed_data = 1;
    this.getItems(1, '', '', '', '', '',1,'','','','','','');
  }

  downloadLeadData() {
    this.getItems(1, '', '', '', '', '', '', '', '', '', true,'','');
  }

  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }
      
    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  sort1: any;
  sort2: any;
  orderChange(id:any, id2:any) {
    this.getItems(1, '', '', '', '', '', '', '', '', '', '', id, id2);
  }
}



// WEBPACK FOOTER //
// ./src/app/platform/organisation/zero-to-forty/zero-to-forty.component.ts